import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { ResetPasswordSection } from '../../components/mi/account/resetPassword'
import { StyleBody } from '../../styles/mi'

export const ResetPassword: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <ResetPasswordSection></ResetPasswordSection>
      <MiFooter />
    </StyleBody>
  )
}
